import React from 'react';
import { connect } from 'react-redux'
import { NAME as WORD_PAIRS_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as numberSearchContainerActions } from '../actions'
import NumberSearchImg from "../../../assets/wordpairs.svg"; //TO DO
import { CSSTransition } from "react-transition-group";
import Timer from "../../Timer/container/Timer"
import ProgressInfo from "../../../components/ProgressInfo";
import GameOver from "../../../components/GameOver";
import { strings } from "../../../constants/strings";
import Grid from "./Grid"
import CountDown from "../../../components/CountDown";
import { LETTER_PAIRS } from "../../../constants/letter-pairs";
import { getAlphabetForLetterJumble } from '../../../helpers/alphabetProvider'
import { analyticsActions } from "constants/analytics-actions-id";

import StartOverlay from "components/StartOverlay";

const lang = document.documentElement.lang.slice(0, 2);
const INFINITY = 2000000000

function mapStateToProps(state) {
  return {
    ...state[WORD_PAIRS_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...numberSearchContainerActions,
  dispatch
}, dispatch)

class NumberSearch extends React.Component {
  constructor(props) {
    props.setType({
      generateMatrix: (state) => {
        let newLeftToFind = 0
        let alphabet
        let letterPair = LETTER_PAIRS[lang][Math.floor(Math.random() * LETTER_PAIRS[lang].length)];
        alphabet = [0,1,2,3,4,5,6,7,8,9]
        let newMatrix = []
        for (let i = 0; i < state.GRIG_HEIGHT; i++) {
          let newRow = []
          for (let j = 0; j < state.GRID_WIDTH; j++) {
            let letter
            let randomPositionIndex
            let condition
            do {
              randomPositionIndex = Math.floor(Math.random() * alphabet.length)
              letter = alphabet[randomPositionIndex];
              if(randomPositionIndex === 0) {
                condition = true
              } else {
                condition = alphabet[randomPositionIndex] === alphabet[randomPositionIndex-1]
              }
            } while (condition)
            newRow.push({ value: letter })
          }
          newMatrix.push(newRow)
        }
        for (let i = 0; i <9; i++) {
          let randi
          let randj
          let condition
          do {
            randi = Math.floor(Math.random() * state.GRIG_HEIGHT);            
            randj = Math.floor(Math.random() * state.GRID_WIDTH);            
            condition = letterPair.includes(newMatrix[randi][randj].value)
            if (!condition) {
              newLeftToFind++
              newMatrix[randi][randj] = {
                ...newMatrix[randi][randj],
                value: letterPair[0],
                special: true
              }
            }
          } while (condition)
          do {
            randi = Math.floor(Math.random() * state.GRIG_HEIGHT);
            randj = Math.floor(Math.random() * state.GRID_WIDTH);
            condition = letterPair.includes(newMatrix[randi][randj].value)
            if (!condition) {
              newLeftToFind++
              newMatrix[randi][randj] = {
                ...newMatrix[randi][randj],
                value: letterPair[1],
                special: true
              }
            }
          } while (condition)
        }
        return {
          gameMatrix: newMatrix,
          leftToFind: 18,
          lettersToFind: letterPair
        }
      }
    })
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
  }

  componentWillUnmount() {

  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ startOverlayTransitionIsFinished: true })}
        >
          <StartOverlay
            img={NumberSearchImg}
            name={strings.NumberSearch_name}
            title={strings.NumberSearch_title}
            description={strings.NumberSearch_description}
            btnText={strings.OverlayView_btn_start}
            btnId={analyticsActions.NumberSearch.btnStart}
            onClick={() => { this.props.startPreExersize() }}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          <GameOver
            title={strings.NumberSearch_name}
            points={this.props.points}
            countDown={this.props.countDown}
            exersizeState={this.props.exersizeState}
            lettersMatrix={this.props.lettersMatrix}
            analyticsActions={analyticsActions.NumberSearch}
          />
        </CSSTransition>
        <CSSTransition
          in={
            (
              this.props.exersizeState === 'preexersize' ||
              this.props.exersizeState === 'gameStarted' ||
              this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ progressInfoTransitionIsFinished: true })}
        >

          <ProgressInfo
            timeLeft={this.props.timeLeft}
            points={this.props.points}
            name={strings.NumberSearch_name}
            title={strings.NumberSearch_title}
            game={
              <>
                <Timer
                  started={this.props.exersizeState === 'preexersize'}
                  increment={this.props.incrementCountDown}
                  interval={1000}
                  incrementCounter={this.props.countDown}
                  timerFinished={this.props.startGame}
                />
                <Timer
                  started={this.props.exersizeState === 'gameStarted'}
                  increment={this.props.increment}
                  interval={1000}
                  incrementCounter={this.props.timeLeft}
                  timerFinished={this.props.gameOverAction}
                />
                <CountDown key="countDown" countDown={this.props.countDown} />
                <Grid
                  exName="letter-search"
                  key="grid"
                  exersizeState={this.props.exersizeState}
                  onCellClick={this.props.cellClickAction}
                />
              </>
            }
          >
            <div className="col-md-6 col-sm-6">
              {strings.SLMB_gesucht}{" "}
              <span className="value">
                {this.props.lettersToFind.join(" · ")}
              </span>
            </div>
            <div className="col-md-6 col-sm-6">
              {strings.SLMB_remaining}{" "}
              <span className="value">
                {this.props.leftToFind}
              </span>
            </div>
          </ProgressInfo>
        </CSSTransition>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NumberSearch)
